/**
 * Side-effect imports so sync handlers register before `syncQueue.processQueue()`.
 */

import '@/services/documentUploadQueue';
import '@/services/expenses';
import '@/services/trips';
import '@/services/itinerary';
import '@/services/comments';
import '@/services/maybeItems';
import '@/services/syncQueueDeferredHandlers';
